export default __webpack_public_path__ + "static/media/han-recall-landing.56c8a939.png";